import { useAuthStore } from '../../auth/stores/authStore';
import { extractUserInfo } from '@billda/shared-ui';

export function getGreeting(
  firstName: string,
  hour: number = new Date().getHours()
): string {
  if (hour < 12) return `Good morning, ${firstName}`;
  if (hour < 18) return `Good afternoon, ${firstName}`;
  return `Good evening, ${firstName}`;
}

export function useGreeting(): string {
  const token = useAuthStore(state => state.token);
  const userInfo = extractUserInfo(token);
  const firstName = userInfo?.firstName || 'there';
  return getGreeting(firstName);
}
